import React from "react";
import { Box, Typography } from "@mui/material";

export default function ({ sx, label }) {
  return (
    <Box
      sx={{
        borderRadius: "8px",
        backgroundColor: "#283237",
        textAlign: "center",
        padding: "16px",
        ...sx,
      }}
    >
      <Typography
        color="white"
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
      >
        {label}
      </Typography>
    </Box>
  );
}
